var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"ma-0",attrs:{"justify":"center"}},[_c('h2',[_vm._v("Kóða vantar")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }